function BottomNav(props) {
  return (
    <div
      style={{ paddingTop: "1rem", textAlign: "center", color: "lightgray" }}
    >
      <i>
        FindTune proof-of-concept-0.5.0 | Marcus Gustafsson 2021-2025
        <br />
        OBS! Denna sida är endast en förstudie för en sökmotor för folkmusik!
        <br />
        Data från folkwiki.se och sls.fi
      </i>
    </div>
    /* <BottomNavigation
            showLabels
        >
            <BottomNavigationAction label="Home" icon={<HomeOutlined />}></BottomNavigationAction>
            <BottomNavigationAction label="Search" icon={<SearchRounded />}></BottomNavigationAction>
        </BottomNavigation>*/
  );
}

export default BottomNav;
